
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bigwhitepass",
      function () {
        return require("private-next-pages/bigwhitepass.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bigwhitepass"])
      });
    }
  